import React from 'react'
import styled from 'styled-components'
import { Container } from 'reactstrap'
import _ from 'lodash'

import SectionMain from '~/components/pages/Section'
import { SubSectionTitle } from '~/components/Title'
import Highlight from '~/components/Highlight'

import Logo1 from '~/../assets/logos/deloitte.png'
import Logo2 from '~/../assets/logos/bbva.png'
import Logo3 from '~/../assets/logos/sapientRazorfish.png'
import Logo4 from '~/../assets/logos/securityBank.png'
import Logo5 from '~/../assets/logos/smile.png'
import Logo6 from '~/../assets/logos/accenture.png'
import Logo7 from '~/../assets/logos/linkedIn.png'
import Logo8 from '~/../assets/logos/verizon.png'
import Logo9 from '~/../assets/logos/mcKinsey.png'
import Logo10 from '~/../assets/logos/harvard.png'
import Logo11 from '~/../assets/logos/TravisCI.png'
import Logo12 from '~/../assets/logos/dukeUniversity.png'
import Logo13 from '~/../assets/logos/google.png'
import Logo14 from '~/../assets/logos/zendesk.png'

const Logos = styled.div`
  display: grid;
  grid-template-areas: 'img img img';
  grid-gap: 3rem;

  align-items: center;

  @media screen and (min-width: 576px) {
    grid-template-areas: '1fr 1fr 1fr 1fr 1fr';
  }

  @media screen and (min-width: 768px) {
    grid-template-areas: '1fr 1fr 1fr 1fr 1fr 1fr';
  }

  @media screen and (min-width: 1024px) {
    grid-template-areas: '1fr 1fr 1fr 1fr 1fr 1fr 1fr';
  }
`

const Logo = styled.img`
  width: 100%;
  text-align: center;
  filter: saturate(100%) grayscale(100);
`

export const LogosRow = ({ className, number = 14 }) => {
  const lodash = _
  return (
    <Logos className={className}>
      {lodash.take(
        lodash.shuffle([
          <Logo src={Logo1} alt="Logo 1" />,
          <Logo src={Logo2} alt="Logo 2" />,
          <Logo src={Logo3} alt="Logo 3" />,
          <Logo src={Logo4} alt="Logo 4" />,
          <Logo src={Logo5} alt="Logo 5" />,
          <Logo src={Logo6} alt="Logo 6" />,
          <Logo src={Logo7} alt="Logo 7" />,
          <Logo src={Logo8} alt="Logo 8" />,
          <Logo src={Logo9} alt="Logo 9" />,
          <Logo src={Logo10} alt="Logo 10" />,
          <Logo src={Logo11} alt="Logo 11" />,
          <Logo src={Logo12} alt="Logo 12" />,
          <Logo src={Logo13} alt="Logo 13" />,
          <Logo src={Logo14} alt="Logo 14" />,
        ]),
        number
      )}
    </Logos>
  )
}

export default () => (
  <SectionMain backgroundColor="medium" size="large" textAlign="center">
    <Container>
      <SubSectionTitle size="1.0rem">
        <Highlight>Used by</Highlight>
        <LogosRow className="mt-5" />
      </SubSectionTitle>
    </Container>
  </SectionMain>
)



// WEBPACK FOOTER //
// ./src/components/pages/index/Logos.js